import React, { useState } from 'react';
import { Modal } from '../ui/Modal';
import { Button } from '../ui/Button';
import { Input } from '../ui/Input';
import { Select } from '../ui/Select';
import { mockOrganizations } from '../../utils/mockData';
interface EditStoreDetailsModalProps {
  isOpen: boolean;
  onClose: () => void;
  storeName: string;
  organizationId: string;
  supportEmail: string;
  supportPhone: string;
  onSave: (data: {
    storeName: string;
    organizationId: string;
    supportEmail: string;
    supportPhone: string;
  }) => void;
}
export function EditStoreDetailsModal({
  isOpen,
  onClose,
  storeName,
  organizationId,
  supportEmail,
  supportPhone,
  onSave
}: EditStoreDetailsModalProps) {
  const [formData, setFormData] = useState({
    storeName,
    organizationId,
    supportEmail,
    supportPhone
  });
  const handleSave = () => {
    onSave(formData);
    onClose();
  };
  return <Modal isOpen={isOpen} onClose={onClose} title="Edit Store Details" size="md" footer={<>
          <Button variant="outline" onClick={onClose} data-id="element-160">
            Cancel
          </Button>
          <Button onClick={handleSave} data-id="element-161">Save Changes</Button>
        </>} data-id="element-159">
      <div className="space-y-4" data-id="element-162">
        <Input label="Store Name" value={formData.storeName} onChange={e => setFormData(prev => ({
        ...prev,
        storeName: e.target.value
      }))} placeholder="e.g., Lincoln High Football Fall 2024" data-id="element-163" />

        <Select label="Organization" value={formData.organizationId} onChange={e => setFormData(prev => ({
        ...prev,
        organizationId: e.target.value
      }))} options={[{
        value: '',
        label: 'Select Organization...'
      }, ...mockOrganizations.map(o => ({
        value: o.id,
        label: o.name
      }))]} data-id="element-164" />

        <Input label="Support Email" type="email" value={formData.supportEmail} onChange={e => setFormData(prev => ({
        ...prev,
        supportEmail: e.target.value
      }))} placeholder="support@printer.com" data-id="element-165" />

        <Input label="Support Phone" type="tel" value={formData.supportPhone} onChange={e => setFormData(prev => ({
        ...prev,
        supportPhone: e.target.value
      }))} placeholder="(555) 123-4567" data-id="element-166" />
      </div>
    </Modal>;
}